import styled from "@emotion/styled";
import { BorderRadius, Spacing } from "@snapchat/snap-design-system";

export const ListOfOrgContainers = styled.ul`
    overflow-y: auto;
    margin-top: ${Spacing.MD}px;
    margin-bottom: 0;
    list-style-type: none;
`;

export const ContainersNav = styled.nav`
    overflow-y: auto;

    width: 253px;
    max-height: 80vh;
    padding: ${Spacing.MD}px ${Spacing.SM}px ${Spacing.SM}px;

    border-radius: ${BorderRadius.container}px;
`;
